export const getFormattedCarNameAllUppercase = (incomingCarMake) => {
    const wordArray = incomingCarMake.split(' ');

    const mappedWordArray = wordArray.map((word) => {
        const finalWordString = word.toUpperCase();
        return finalWordString;
    });

    return mappedWordArray.join(' ');
};
